export default "__VITE_ASSET__jyMVYkhB__"